<template>
  <el-cascader
    :props="props"
    v-bind="$attrs"
    :value="value"
    @input="$emit('input', $event)"
  ></el-cascader>
</template>

<script>
import { Cascader } from 'element-ui'
export default {
  components: {
    [Cascader.name]: Cascader
  },
  props: {
    /**
     * parent value
     */
    bizDscd: String,
    pdTpCd: String,
    pdTmpltCd: String,
    value: Array
  },
  data() {
    return {
      props: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node
          if (level == 0) {
            resolve([
              { label: 'Deposit', value: '01', leaf: false },
              { label: 'Loan', value: '02', leaf: false }
            ])
          } else {
            this.fetchPdOption(node, resolve)
          }
        }
      },
      options: []
    }
  },
  methods: {
    async fetchBizDscd(node, resolve) {
      let res = await this.$api.requestCBB('PCM0038400', {
        CmnCdSvcGetCdListByCdNbrIn: {
          cdNbr: '80015'
        }
      })
      if (res.CmnCdSvcGetCdListByCdNbrOut) {
        const nodes = res.CmnCdSvcGetCdListByCdNbrOut.tbl.map(item => {
          return {
            value: item.cd,
            label: item.cdNm,
            leaf: false
          }
        })
        resolve(nodes)
      }
    },
    async fetchPdOption(node, resolve) {
      console.log('fetchPdOption', node, this.value)
      const { pathNodes } = node
      let bizDscd = pathNodes[0]?.value
      let pdTpCd = pathNodes[1]?.value
      let pdTmpltCd = pathNodes[2]?.value

      let res = await this.$api.requestCBB('SPD0010401', {
        PdTxSrvcMgmtSvcIn: {
          bizDscd: bizDscd,
          pdTmpltCd: pdTmpltCd,
          pdTpCd: pdTpCd
        }
      })
      if (res.PdTxSrvcMgmtSvcOut) {
        resolve(
          res.PdTxSrvcMgmtSvcOut.tbl.map(item => {
            return {
              value: item.pdCd,
              label: item.pdNm,
              leaf: !!pdTmpltCd
            }
          })
        )
      }
    }
  }
}
</script>

<style></style>
